(function () {

  function init(root) {

    if (!root || root.dataset.mlpbReady === '1') return;

    root.dataset.mlpbReady = '1';


    var tiers = [
      { qty: 2, discount: 10 },
      { qty: 3, discount: 15 },
      { qty: 4, discount: 20 },
      { qty: 5, discount: 25 },
      { qty: 6, discount: 30 }
    ];


    var currency =
      root.dataset.currency || 'USD';


    var singleBuyButton =
      root.querySelector('#mlpbSingleBuyButton');

    var singleBuyText =
      root.querySelector('#mlpbSingleBuyText');

    var bundleBuyButton =
      root.querySelector('#mlpbBundleBuyButton');

    var bundleBuyText =
      root.querySelector('#mlpbBundleBuyText');

    var addGame =
      root.querySelector('#mlpbAddGame');

    var selected =
      root.querySelector('#mlpbSelected');

    var activeBundle =
      root.querySelector('#mlpbActiveBundle');

    var activeTitle =
      root.querySelector('#mlpbActiveTitle');

    var activeDiscount =
      root.querySelector('#mlpbActiveDiscount');

    var bundleMeta =
      root.querySelector('#mlpbBundleMeta');

    var bundleNote =
      root.querySelector('#mlpbBundleNote');

    var bundleTotal =
      root.querySelector('#mlpbBundleTotal');

    var saveHeading =
      root.querySelector('#mlpbSaveHeading');

    var nextSaving =
      root.querySelector('#mlpbNextSaving');


    var licenseSelect =
      root.querySelector('#mlpbLicense');

    var licenseDescription =
      root.querySelector('#mlpbLicenseDescription');

    var licenseOrgWrap =
      root.querySelector('#mlpbLicenseOrgWrap');

    var licenseOrg =
      root.querySelector('#mlpbLicenseOrg');

    var licenseError =
      root.querySelector('#mlpbLicenseError');


    var picker =
      root.querySelector('#mlpbPicker');

    var pickerClose =
      root.querySelector('#mlpbPickerClose');

    var done =
      root.querySelector('#mlpbDone');

    var search =
      root.querySelector('#mlpbSearch');

    var sort =
      root.querySelector('#mlpbSort');

    var productGrid =
      root.querySelector('#mlpbProducts');

    var empty =
      root.querySelector('#mlpbEmpty');


    var pickerCount =
      root.querySelector('#mlpbPickerCount');

    var pickerSaving =
      root.querySelector('#mlpbPickerSaving');

    var footerCount =
      root.querySelector('#mlpbFooterCount');

    var footerSaving =
      root.querySelector('#mlpbFooterSaving');

    var footerDiscount =
      root.querySelector('#mlpbFooterDiscount');

    var progressHeadline =
      root.querySelector('#mlpbProgressHeadline');

    var progressSubline =
      root.querySelector('#mlpbProgressSubline');

    var progressFill =
      root.querySelector('#mlpbProgressFill');


    var cards =
      Array.prototype.slice.call(
        root.querySelectorAll('.mlpb-product')
      );

    var filters =
      Array.prototype.slice.call(
        root.querySelectorAll('.mlpb-filter')
      );

    var progressSteps =
      Array.prototype.slice.call(
        root.querySelectorAll('.mlpb-progress-step')
      );


    var activeFilter = 'all';


    if (
      picker &&
      picker.parentNode !== document.body
    ) {

      document.body.appendChild(picker);

    }


    function money(cents) {

      cents =
        parseInt(cents, 10) || 0;

      try {

        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          {
            style: 'currency',
            currency: currency
          }
        ).format(cents / 100);

      } catch (error) {

        return (
          cents / 100
        ).toFixed(2);

      }

    }


    function selectedItems() {

      return Array.prototype.slice.call(
        root.querySelectorAll(
          '.mlpb-selected-item'
        )
      );

    }


    function discountFor(quantity) {

      var discount = 0;

      tiers.forEach(
        function (tier) {

          if (
            quantity >= tier.qty
          ) {

            discount =
              tier.discount;

          }

        }
      );

      return discount;

    }


    function nextTier(quantity) {

      for (
        var i = 0;
        i < tiers.length;
        i++
      ) {

        if (
          quantity < tiers[i].qty
        ) {

          return tiers[i];

        }

      }

      return null;

    }


    function getLicense() {

      var option =
        licenseSelect.options[
          licenseSelect.selectedIndex
        ];


      return {

        value:
          option.value,

        label:
          option.dataset.label ||
          option.textContent.trim(),

        variantId:
          parseInt(
            option.dataset.variantId,
            10
          ) || 0,

        price:
          parseInt(
            option.dataset.price,
            10
          ) || 0,

        organization:
          licenseOrg.value.trim()

      };

    }


    function updateLicenseUI() {

      var license =
        getLicense();


      var selectedOption =
        licenseSelect.options[
          licenseSelect.selectedIndex
        ];


      var description =
        selectedOption.dataset.description ||
        '';


      if (
        licenseDescription
      ) {

        licenseDescription.textContent =
          description;

      }


      var needsOrganization =
        license.value !== 'personal';


      licenseOrgWrap.hidden =
        !needsOrganization;


      if (
        !needsOrganization
      ) {

        licenseOrg.value =
          '';


        licenseOrg.classList.remove(
          'is-error'
        );


        licenseError.hidden =
          true;

      }


      update();

    }


    function validateLicense() {

      var license =
        getLicense();


      if (
        license.value !== 'personal' &&
        !license.organization
      ) {

        licenseOrgWrap.hidden =
          false;


        licenseOrg.classList.add(
          'is-error'
        );


        licenseError.hidden =
          false;


        licenseOrg.focus();


        return false;

      }


      licenseOrg.classList.remove(
        'is-error'
      );


      licenseError.hidden =
        true;


      return true;

    }


    function gameProperties() {

  var license =
    getLicense();


  var properties = {

    'License':
      license.label,

    '_ML bundle eligible':
      'yes'

  };


      if (
        license.organization
      ) {

        properties['Licensed to'] =
          license.organization;

      }


      return properties;

    }


    function licenseAddonItem(gameQuantity) {

      var license =
        getLicense();


      if (
        !license.variantId ||
        !gameQuantity
      ) {

        return null;

      }


      var properties = {

        '_License type':
          license.label,

        '_License basis':
          'Per game',

        '_Licensed games':
          String(gameQuantity)

      };


      if (
        license.organization
      ) {

        properties['_Licensed to'] =
          license.organization;

      }


      return {

        id:
          license.variantId,

        quantity:
          gameQuantity,

        properties:
          properties

      };

    }


    function progressWidth(quantity) {

      if (
        quantity <= 2
      ) {

        return 0;

      }


      var capped =
        Math.min(
          quantity,
          6
        );


      return (
        (
          capped - 2
        ) /
        4
      ) * 80;

    }


    function updateDisplayedPrices(discount) {

      root
        .querySelectorAll(
          '.mlpb-item-price'
        )
        .forEach(
          function (priceBox) {

            var original =
              parseInt(
                priceBox.dataset.originalPrice,
                10
              ) || 0;


            var originalEl =
              priceBox.querySelector(
                '.mlpb-item-original'
              );


            var discountedEl =
              priceBox.querySelector(
                '.mlpb-item-discounted'
              );


            if (
              !originalEl ||
              !discountedEl
            ) {

              return;

            }


            if (
              !discount
            ) {

              originalEl.style.display =
                'none';


              originalEl.textContent =
                '';


              discountedEl.textContent =
                money(original);


              discountedEl.style.color =
                '#252d83';


              return;

            }


            var discounted =
              Math.round(
                original *
                (
                  1 -
                  discount /
                  100
                )
              );


            originalEl.style.display =
              'inline';


            originalEl.textContent =
              money(original);


            discountedEl.textContent =
              money(discounted);


            discountedEl.style.color =
              '#ef3d43';

          }
        );


      cards.forEach(
        function (card) {

          var priceBox =
            card.querySelector(
              '.mlpb-product-price'
            );


          if (
            !priceBox
          ) {

            return;

          }


          var original =
            parseInt(
              priceBox.dataset.originalPrice,
              10
            ) || 0;


          var originalEl =
            priceBox.querySelector(
              '.mlpb-picker-original'
            );


          var discountedEl =
            priceBox.querySelector(
              '.mlpb-picker-discounted'
            );


          if (
            !originalEl ||
            !discountedEl
          ) {

            return;

          }


          if (
            !discount
          ) {

            originalEl.style.display =
              'none';


            originalEl.textContent =
              '';


            discountedEl.textContent =
              money(original);


            discountedEl.style.color =
              '#252d83';


            return;

          }


          var discounted =
            Math.round(
              original *
              (
                1 -
                discount /
                100
              )
            );


          originalEl.style.display =
            'inline';


          originalEl.textContent =
            money(original);


          discountedEl.textContent =
            money(discounted);


          discountedEl.style.color =
            '#ef3d43';

        }
      );

    }


    function update() {

      var items =
        selectedItems();


      var quantity =
        items.length;


      var discount =
        discountFor(quantity);


      var next =
        nextTier(quantity);


      var license =
        getLicense();


      var gameSubtotal =
        0;


      items.forEach(
        function (item) {

          gameSubtotal +=
            parseInt(
              item.dataset.price,
              10
            ) || 0;

        }
      );


      var savingAmount =
        Math.round(
          gameSubtotal *
          discount /
          100
        );


      var discountedGames =
        gameSubtotal -
        savingAmount;


      var licenseTotal =
        license.price *
        quantity;


      var finalTotal =
        discountedGames +
        licenseTotal;


      updateDisplayedPrices(
        discount
      );


      var countText =
        quantity +
        (
          quantity === 1
            ? ' game selected'
            : ' games selected'
        );


      pickerCount.textContent =
        countText;


      footerCount.textContent =
        countText;


      if (
        quantity > 1
      ) {

        activeBundle.hidden =
          false;


        singleBuyButton.style.setProperty(
          'display',
          'none',
          'important'
        );


        activeDiscount.textContent =
          discount +
          '% OFF';


        activeTitle.textContent =
          discount +
          '% bundle savings unlocked';


        bundleMeta.textContent =
          quantity +
          ' games · You save ' +
          money(
            savingAmount
          );


        bundleTotal.textContent =
          money(
            finalTotal
          );


        if (
          license.price > 0
        ) {

          bundleNote.textContent =
            license.label +
            ' license · ' +
            quantity +
            ' × ' +
            money(
              license.price
            ) +
            ' per game';

        } else {

          bundleNote.textContent =
            'Automatic discount applied at checkout';

        }


        if (
          saveHeading
        ) {

          saveHeading.textContent =
            next
              ? 'Add another game to unlock ' +
                next.discount +
                '% OFF'
              : 'Maximum 30% OFF unlocked';

        }

      } else {

        activeBundle.hidden =
          true;


        singleBuyButton.style.removeProperty(
          'display'
        );


        if (
          saveHeading
        ) {

          saveHeading.textContent =
            'Build a bundle and save up to 30%';

        }

      }


      if (
        next
      ) {

        var needed =
          next.qty -
          quantity;


        var nextMessage =
          'Add ' +
          needed +
          (
            needed === 1
              ? ' more game to unlock '
              : ' more games to unlock '
          ) +
          next.discount +
          '% OFF';


        pickerSaving.textContent =
          nextMessage;


        footerSaving.textContent =
          nextMessage;


        if (
          discount > 0
        ) {

          nextSaving.textContent =
            discount +
            '% OFF unlocked · Next ' +
            next.discount +
            '%';


          progressHeadline.textContent =
            discount +
            '% OFF unlocked';


          progressSubline.textContent =
            nextMessage;

        } else {

          nextSaving.textContent =
            'Unlock ' +
            next.discount +
            '% OFF';


          progressHeadline.textContent =
            'Add one more game to save 10%';


          progressSubline.textContent =
            'Every extra game moves you to the next discount tier.';

        }

      } else {

        pickerSaving.textContent =
          'Maximum 30% OFF unlocked';


        footerSaving.textContent =
          'Maximum discount unlocked';


        nextSaving.textContent =
          '30% OFF unlocked';


        progressHeadline.textContent =
          '30% OFF unlocked';


        progressSubline.textContent =
          'You reached the maximum bundle discount.';

      }


      if (
        discount > 0
      ) {

        footerDiscount.hidden =
          false;


        footerDiscount.textContent =
          discount +
          '% OFF';

      } else {

        footerDiscount.hidden =
          true;

      }


      progressFill.style.width =
        progressWidth(
          quantity
        ) +
        '%';


      progressSteps.forEach(
        function (step) {

          var qty =
            parseInt(
              step.dataset.qty,
              10
            );


          step.classList.toggle(
            'is-active',
            quantity >= qty
          );


          step.classList.toggle(
            'is-next',
            next &&
            next.qty === qty
          );

        }
      );


      cards.forEach(
        function (card) {

          var id =
            card.dataset.productId;


          var exists =
            root.querySelector(
              '.mlpb-selected-item[data-product-id="' +
              id +
              '"]'
            );


          card.classList.toggle(
            'is-selected',
            !!exists
          );

        }
      );

    }


    function refreshJudgeMe() {

      window.setTimeout(
        function () {

          if (
            window.jdgm &&
            typeof window.jdgm.initializeWidgets ===
            'function'
          ) {

            window.jdgm.initializeWidgets();

          }

        },
        50
      );

    }


    function openPicker() {

      picker.classList.add(
        'is-open'
      );


      picker.setAttribute(
        'aria-hidden',
        'false'
      );


      document.documentElement
        .classList.add(
          'mlpb-picker-open'
        );


      document.body
        .classList.add(
          'mlpb-picker-open'
        );


      update();


      filterAndSort();


      refreshJudgeMe();

    }


    function closePicker() {

      picker.classList.remove(
        'is-open'
      );


      picker.setAttribute(
        'aria-hidden',
        'true'
      );


      document.documentElement
        .classList.remove(
          'mlpb-picker-open'
        );


      document.body
        .classList.remove(
          'mlpb-picker-open'
        );


      update();

    }


    function filterAndSort() {

      var query =
        search.value
          .toLowerCase()
          .trim();


      var mode =
        sort.value;


      var sorted =
        cards.slice();


      sorted.sort(
        function (a, b) {

          if (
            mode === 'az'
          ) {

            return (
              a.dataset.sortTitle ||
              ''
            ).localeCompare(
              b.dataset.sortTitle ||
              ''
            );

          }


          if (
            mode === 'za'
          ) {

            return (
              b.dataset.sortTitle ||
              ''
            ).localeCompare(
              a.dataset.sortTitle ||
              ''
            );

          }


          if (
            mode === 'price-low'
          ) {

            return (
              parseInt(
                a.dataset.price,
                10
              ) || 0
            ) -
            (
              parseInt(
                b.dataset.price,
                10
              ) || 0
            );

          }


          if (
            mode === 'price-high'
          ) {

            return (
              parseInt(
                b.dataset.price,
                10
              ) || 0
            ) -
            (
              parseInt(
                a.dataset.price,
                10
              ) || 0
            );

          }


          return (
            parseInt(
              a.dataset.order,
              10
            ) || 0
          ) -
          (
            parseInt(
              b.dataset.order,
              10
            ) || 0
          );

        }
      );


      sorted.forEach(
        function (card) {

          productGrid.appendChild(
            card
          );

        }
      );


      var visible =
        0;


      sorted.forEach(
        function (card) {

          var title =
            (
              card.dataset.title ||
              ''
            ).toLowerCase();


          var categories =
            (
              card.dataset.categories ||
              ''
            )
            .toLowerCase()
            .split(/\s+/);


          var searchMatch =
            !query ||
            title.indexOf(
              query
            ) !== -1;


          var categoryMatch =
            activeFilter === 'all' ||
            categories.indexOf(
              activeFilter
            ) !== -1;


          if (
            searchMatch &&
            categoryMatch
          ) {

            card.style.setProperty(
              'display',
              'flex',
              'important'
            );


            visible++;

          } else {

            card.style.setProperty(
              'display',
              'none',
              'important'
            );

          }

        }
      );


      empty.style.setProperty(
        'display',
        visible
          ? 'none'
          : 'flex',
        'important'
      );

    }


    function fireConfetti() {

      if (
        typeof window.confetti !== 'function'
      ) {

        return;

      }


      if (
        window.matchMedia &&
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {

        return;

      }


      var colors = [
        '#252d83',
        '#ef3d43',
        '#fff1df',
        '#f2bf49'
      ];


      window.confetti({

        particleCount:
          45,

        spread:
          65,

        startVelocity:
          32,

        scalar:
          0.9,

        zIndex:
          2147483647,

        origin: {
          x: 0.25,
          y: 0.8
        },

        colors:
          colors

      });


      window.setTimeout(
        function () {

          window.confetti({

            particleCount:
              45,

            spread:
              65,

            startVelocity:
              32,

            scalar:
              0.9,

            zIndex:
              2147483647,

            origin: {
              x: 0.75,
              y: 0.8
            },

            colors:
              colors

          });

        },
        120
      );

    }


    function openCustomCart() {

  document.dispatchEvent(
    new CustomEvent(
      'ml:cart:open',
      {
        bubbles: true
      }
    )
  );

}


    function addItemsToCart(
      items,
      button,
      textElement,
      addingText,
      successText
    ) {

      if (
        !items.length
      ) {

        return;

      }


      button.disabled =
        true;


      textElement.textContent =
        addingText;


      fetch(
        '/cart/add.js',
        {

          method:
            'POST',

          credentials:
            'same-origin',

          headers: {

            'Content-Type':
              'application/json',

            'Accept':
              'application/json'

          },

          body:
            JSON.stringify({
              items:
                items
            })

        }
      )

      .then(
        function (response) {

          if (
            !response.ok
          ) {

            return response
              .json()
              .catch(
                function () {

                  return {};

                }
              )
              .then(
                function (errorData) {

                  throw new Error(
                    errorData.description ||
                    errorData.message ||
                    'Could not add item to cart.'
                  );

                }
              );

          }


          return response.json();

        }
      )

      .then(
        function () {

          textElement.textContent =
            successText;


          fireConfetti();


          window.setTimeout(
            function () {

              openCustomCart();

            },
            120
          );


          button.disabled =
            false;


          window.setTimeout(
            function () {

              if (
                button === singleBuyButton
              ) {

                textElement.textContent =
                  'ADD TO CART';

              } else {

                textElement.textContent =
                  'ADD BUNDLE TO CART';

              }

            },
            1800
          );

        }
      )

      .catch(
        function (error) {

          console.error(
            'MysteryLocks cart error:',
            error
          );


          button.disabled =
            false;


          textElement.textContent =
            'TRY AGAIN';


          window.setTimeout(
            function () {

              if (
                button === singleBuyButton
              ) {

                textElement.textContent =
                  'ADD TO CART';

              } else {

                textElement.textContent =
                  'ADD BUNDLE TO CART';

              }

            },
            1800
          );

        }
      );

    }


    function buildGameItem(variantId) {

      return {

        id:
          parseInt(
            variantId,
            10
          ),

        quantity:
          1,

        properties:
          gameProperties()

      };

    }


    licenseSelect.addEventListener(
      'change',
      updateLicenseUI
    );


    licenseOrg.addEventListener(
      'input',
      function () {

        licenseOrg.classList.remove(
          'is-error'
        );


        licenseError.hidden =
          true;


        update();

      }
    );


    addGame.addEventListener(
      'click',
      openPicker
    );


    pickerClose.addEventListener(
      'click',
      closePicker
    );


    done.addEventListener(
      'click',
      closePicker
    );


    picker.addEventListener(
      'click',
      function (event) {

        if (
          event.target === picker
        ) {

          closePicker();

        }

      }
    );


    cards.forEach(
      function (card) {

        card.addEventListener(
          'click',
          function () {

            var productId =
              card.dataset.productId;


            var existing =
              root.querySelector(
                '.mlpb-selected-item[data-product-id="' +
                productId +
                '"]'
              );


            if (
              existing
            ) {

              if (
                existing.classList.contains(
                  'mlpb-current-item'
                )
              ) {

                return;

              }


              existing.remove();


              update();


              return;

            }


            var item =
              document.createElement(
                'div'
              );


            item.className =
              'mlpb-selected-item mlpb-extra-item';


            item.dataset.productId =
              productId;


            item.dataset.variantId =
              card.dataset.variantId;


            item.dataset.price =
              card.dataset.price;


            var image =
              card.dataset.image ||
              '';


            var title =
              card.dataset.title ||
              '';


            var originalPrice =
              card.dataset.price ||
              '0';


            var formattedPrice =
              card.dataset.priceFormatted ||
              '';


            item.innerHTML =

              '<div class="mlpb-extra-image">' +

                (
                  image
                    ? '<img src="' +
                      image +
                      '" alt="">'
                    : ''
                ) +

              '</div>' +


              '<div class="mlpb-extra-copy">' +

                '<strong>' +
                  title +
                '</strong>' +


                '<div class="mlpb-item-price" data-original-price="' +
                  originalPrice +
                '">' +

                  '<span class="mlpb-item-original"></span>' +

                  '<strong class="mlpb-item-discounted">' +
                    formattedPrice +
                  '</strong>' +

                '</div>' +

              '</div>' +


              '<button type="button" class="mlpb-remove" aria-label="Remove game">×</button>';


            selected.appendChild(
              item
            );


            update();

          }
        );

      }
    );


    selected.addEventListener(
      'click',
      function (event) {

        var remove =
          event.target.closest(
            '.mlpb-remove'
          );


        if (
          !remove
        ) {

          return;

        }


        var item =
          remove.closest(
            '.mlpb-extra-item'
          );


        if (
          item
        ) {

          item.remove();


          update();

        }

      }
    );


    filters.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {

            activeFilter =
              button.dataset.filter;


            filters.forEach(
              function (other) {

                other.classList.remove(
                  'is-active'
                );

              }
            );


            button.classList.add(
              'is-active'
            );


            filterAndSort();

          }
        );

      }
    );


    search.addEventListener(
      'input',
      filterAndSort
    );


    sort.addEventListener(
      'change',
      filterAndSort
    );


    singleBuyButton.addEventListener(
      'click',
      function () {

        if (
          !validateLicense()
        ) {

          return;

        }


        var items = [

          buildGameItem(
            root.dataset.currentVariant
          )

        ];


        var licenseItem =
          licenseAddonItem(
            1
          );


        if (
          licenseItem
        ) {

          items.push(
            licenseItem
          );

        }


        addItemsToCart(

          items,

          singleBuyButton,

          singleBuyText,

          'ADDING...',

          'ADDED ✓'

        );

      }
    );


    bundleBuyButton.addEventListener(
      'click',
      function () {

        if (
          !validateLicense()
        ) {

          return;

        }


        var gameItems =
          selectedItems()

          .map(
            function (item) {

              return buildGameItem(
                item.dataset.variantId
              );

            }
          )

          .filter(
            function (item) {

              return !!item.id;

            }
          );


        var gameQuantity =
          gameItems.length;


        var licenseItem =
          licenseAddonItem(
            gameQuantity
          );


        if (
          licenseItem
        ) {

          gameItems.push(
            licenseItem
          );

        }


        addItemsToCart(

          gameItems,

          bundleBuyButton,

          bundleBuyText,

          'ADDING BUNDLE...',

          'BUNDLE ADDED ✓'

        );

      }
    );


    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          picker.classList.contains(
            'is-open'
          )
        ) {

          closePicker();

        }

      }
    );


    updateLicenseUI();

    filterAndSort();

  }


  function boot() {

    document
      .querySelectorAll(
        '[data-mlpb-root]'
      )
      .forEach(
        init
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();

  }

})();